<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.modulo"
        ref="RkmDataTable"
    />
</template>

<script>
export default {
    computed: {
        fields() {
            return [
                {key: 'sistema_nome', label: 'Nome', name: 'cadastro_sistema.nome', searchable: true, sortable: true},
                {key: 'modulo_nome', label: 'Nome', name: 'cadastro_modulo.nome', searchable: true, sortable: true},
                {key: 'modulo_identificador', label: 'Identificador', name: 'cadastro_modulo.identificador', searchable: true, sortable: true}
            ]
        },
    },
    inject: ['repositories'],
}
</script>